import { render, staticRenderFns } from "./NoGetCertificateList.vue?vue&type=template&id=34800b89&scoped=true&"
import script from "./NoGetCertificateList.vue?vue&type=script&lang=js&"
export * from "./NoGetCertificateList.vue?vue&type=script&lang=js&"
import style0 from "./NoGetCertificateList.vue?vue&type=style&index=0&id=34800b89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34800b89",
  null
  
)

export default component.exports